module.exports = __webpack_public_path__ + "static/img/digitization4.933175d8.png";